import React, { useState } from "react";
import {
  LayoutDashboard,
  FileText,
  FileSignature,
  Info,
  FileCheck,
  ScrollText,
  ChevronLeft,
  X,Users
} from "lucide-react";

export default function Sidebar({
  isOpen,
  setIsOpen,
  activeSection,
  setActiveSection,
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    {
      section: "Principal",
      items: [
        { id: "inicio", label: "Inicio", icon: LayoutDashboard },
        { id: "documents", label: "Documentos", icon: FileText },
        { id: "templates", label: "Plantillas", icon: FileSignature },
        { id: "clientes", label: "Clientes", icon: Users },
      ],
    },
    {
      section: "Páginas",
      items: [
        { id: "about", label: "Nosotros", icon: Info },
        { id: "policies", label: "Políticas", icon: FileCheck },
        { id: "terms", label: "Términos", icon: ScrollText },
      ],
    },
  ];

  const handleItemClick = (itemId) => {
    setActiveSection(itemId);
    if (window.innerWidth < 1024) setIsOpen(false);
  };

  return (
    <>
      {/* Overlay para móvil */}
      <div
        className={`
          fixed inset-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden
          transition-opacity duration-300
          ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}
        `}
        onClick={() => setIsOpen(false)}
      />

      <aside
        className={`
        fixed lg:static inset-y-0 left-0 z-50
        bg-white border-r border-slate-200 h-screen
        transition-all duration-300 ease-out
        ${isOpen ? "w-64 translate-x-0" : "w-64 -translate-x-full lg:translate-x-0"}
        ${isCollapsed && isOpen ? "lg:w-20" : ""}
        flex flex-col
      `}
      >
        {/* Header del sidebar */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-slate-100 flex-shrink-0">
          <div
            className={`flex items-center gap-3 transition-all duration-300 ${isCollapsed ? "lg:justify-center" : ""}`}
          >
            <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center shadow-lg shadow-blue-600/20 flex-shrink-0">
              <FileSignature className="w-4 h-4 text-white" />
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ${isCollapsed ? "lg:w-0 lg:opacity-0" : "lg:w-auto lg:opacity-100"}`}
            >
              <h1 className="font-bold text-slate-900 text-sm whitespace-nowrap">
                Inkless
              </h1>
            </div>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="lg:hidden p-1.5 hover:bg-slate-100 rounded-lg transition-colors flex-shrink-0"
          >
            <X className="w-5 h-5 text-slate-600" />
          </button>
        </div>

        {/* Navegación */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-6 custom-scrollbar">
          {menuItems.map((group, idx) => (
            <div key={idx}>
              <h3
                className={`px-3 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 transition-all duration-300 ${isCollapsed ? "lg:opacity-0 lg:h-0 lg:mb-0" : ""}`}
              >
                {group.section}
              </h3>
              <div className="space-y-1">
                {group.items.map((item) => {
                  const Icon = item.icon;
                  const isActive = activeSection === item.id;

                  return (
                    <button
                      key={item.id}
                      onClick={() => handleItemClick(item.id)}
                      className={`
                        relative w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium
                        transition-all duration-200 group
                        ${
                          isActive
                            ? "bg-blue-50 text-blue-600"
                            : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                        }
                        ${isCollapsed ? "lg:justify-center lg:px-0" : ""}
                      `}
                      title={isCollapsed ? item.label : undefined}
                    >
                      <Icon
                        className={`w-5 h-5 flex-shrink-0 transition-all duration-200 ${isActive ? "stroke-[2.5px]" : ""}`}
                      />
                      <span
                        className={`transition-all duration-300 whitespace-nowrap ${isCollapsed ? "lg:w-0 lg:opacity-0" : "lg:w-auto lg:opacity-100"}`}
                      >
                        {item.label}
                      </span>
                      {isActive && !isCollapsed && (
                        <div className="ml-auto w-1.5 h-1.5 bg-blue-600 rounded-full" />
                      )}
                      {isActive && isCollapsed && (
                        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-blue-600 rounded-l-full" />
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </nav>
      </aside>

      {/* 👇 CORRECCIÓN: Se eliminó el atributo 'jsx' para evitar el warning de React */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>
    </>
  );
}
